import React, { useState, useEffect, useRef } from "react"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleDown } from "@fortawesome/free-solid-svg-icons"

import "../styles.scss"

export default function ConditionButton() {
  const [toggleShowClass, setToggleShowClass] = useState(false)
  const conditionButtonRef = useRef(null)
  const dropdownRef = useRef(null)

  const toggleBodyLock = () => {
    if (document.body.style.overflowY === "hidden") {
      document.body.style.overflowY = "visible"
    }
  }

  const closeDropdown = () => {
    setToggleShowClass(false)
  }

  const handleDocumentClick = event => {
    if (
      conditionButtonRef.current &&
      !conditionButtonRef.current.contains(event.target)
    ) {
      closeDropdown()
    }
  }

  const toggleHover = () => {
    setToggleShowClass(prevState => !prevState)
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleDocumentClick)

    return () => {
      document.removeEventListener("mousedown", handleDocumentClick)
    }
  }, [])

  // const handleButtonClick = () => {
  //   setToggleShowClass(prevState => !prevState)
  // }

  return (
    <div
      className={`ConditionButton ${toggleShowClass ? "show" : ""}`}
      ref={conditionButtonRef}
      onMouseEnter={toggleHover}
      onMouseLeave={toggleHover}
    >
      <button
        // onClick={handleButtonClick}
        className="dropbtn font-sans-bold"
      >
        CONDITION{" "}
        <span className="icon-arrow-up-down">
          <FontAwesomeIcon icon={faAngleDown} className="condition-arrow" />
        </span>
      </button>
      <div
        id="condition-dropdown"
        className={`dropdown-content font-din-pro-cond ${
          toggleShowClass ? "show" : ""
        }`}
        ref={dropdownRef}
        // onMouseLeave={toggleHover}
      >
        <Link
          to="/ism/"
          partiallyActive={true}
          activeClassName="active"
          onClick={toggleBodyLock}
        >
          Indolent ISM
        </Link>
        <Link
          to="/advsm/"
          partiallyActive={true}
          activeClassName="active"
          onClick={toggleBodyLock}
        >
          Advanced SM
        </Link>
        <Link
          to="/gist-hcp/"
          partiallyActive={true}
          activeClassName="active"
          onClick={toggleBodyLock}
        >
          PDGFRA GIST
        </Link>
      </div>
    </div>
  )
}
